import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './caution-icon.module.css'

const propTypes = {
    backgroundPathClass: PropTypes.string,
    iconPathClass: PropTypes.string,
    outlinePathClass: PropTypes.string
}

/**
 * Define default props as fallback.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    backgroundPathClass: styles['background'],
    iconPathClass: styles['icon'],
    keepPathColor: true,
    outlinePathClass: styles['outline'],
    viewBoxSize: 48
}

/**
 * Stateless function representing a caution icon.
 *
 * @param {Object} [props] - The component properties
 * @param {string} [props.backgroundPathClass] - css class name of the background
 * @param {string} [props.iconPathClass] - css class name of the icon
 * @param {string} [props.outlinePathClass] - css class name of the outline
 *
 * @example
 * <CautionIcon />
 */

const CautionIcon = props => {
    const { backgroundPathClass, iconPathClass, outlinePathClass } = props

    return (
        <SvgIcon {...props}>
            <path
                className={outlinePathClass}
                d={`M42.83,28.83L28.41,4.22A7.43,7.43,0,0,0,22,0a7.43,7.43,0,0,0-6.41,4.22L1.17,28.77a7.61,7.61,0,0,
                0-.25,7.68A8.07,8.07,0,0,0,8,40H36c3,0,5.76-1.26,7.08-3.5A7.61,7.61,0,0,0,42.83,28.83Z`}
            />
            <path
                className={backgroundPathClass}
                d={`M22,2c1.83,0,3.53,1.16,4.68,3.23L41.11,29.84l0,0,0,0a5.62,5.62,0,0,1,.2,5.62A6.11,6.11,0,0,1,36,
                38H7.61a6.06,6.06,0,0,1-5-2.6,5.62,5.62,0,0,1,.23-5.58l0,0,0,0L17.34,5.19A5.5,5.5,0,0,1,22,2`}
            />
            <path className={iconPathClass} d="M22,36.3a3.85,3.85,0,1,1,3.85-3.85h0A3.85,3.85,0,0,1,22,36.3Z" />
            <path
                className={iconPathClass}
                d={`M24.91,23.57a2.71,2.71,0,0,1-2.82,2.59H22a2.73,2.73,0,0,
                1-2.89-2.56v0c-0.12-1.57-1-12.44-1-12.44A3.67,3.67,0,0,1,22,7.68h0a3.67,3.67,0,0,1,3.85,3.45S25,22,
                24.91,23.57Z`}
            />
        </SvgIcon>
    )
}

CautionIcon.propTypes = propTypes
CautionIcon.defaultProps = defaultProps

export { CautionIcon }
